import { Checkbox } from "@dune/ui";
import { BUILDING_USAGE_TYPES } from "@dune/vars";
import { useFormContext, useWatch } from "react-hook-form";

const BuildingUsageContainer = () => {
	const { control, setValue } = useFormContext();

	const actionsValue = useWatch({
		control,
		name: "actions",
	});
	return (
		<div className="flex flex-row gap-4">
			Usage de Bâtiment :
			{Object.keys(BUILDING_USAGE_TYPES).map((key) => (
				<Checkbox
					id={key}
					key={key}
					label={BUILDING_USAGE_TYPES[key as keyof typeof BUILDING_USAGE_TYPES]}
					checked={actionsValue.buildingUsage === key}
					onCheckedChange={(checked) => {
						setValue("actions.buildingUsage", checked ? key : undefined);
					}}
				/>
			))}
		</div>
	);
};

export default BuildingUsageContainer;
